/**
 * Generic typed helpers for persisting filter state in localStorage.
 * Usage:
 *   const saved = getFilters<MyFilters>('MY-KEY');
 *   saveFilters('MY-KEY', { dateFrom, dateTo, employeeIds });
 *   clearFilters('MY-KEY');
 */

export function getFilters<T>(key: string): T | null {
  try {
    const raw = localStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : null;
  } catch {
    return null;
  }
}

export function saveFilters<T>(key: string, filters: T): void {
  try {
    localStorage.setItem(key, JSON.stringify(filters));
  } catch {
    // quota exceeded or private browsing — fail silently
  }
}

export function clearFilters(key: string): void {
  localStorage.removeItem(key);
}
